/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const SmartCreatePageEditorDataWrapperComponentQuery = gql`
	query SmartCreatePageEditorDataWrapperComponentQuery($contentId: ID!) {
		content(id: $contentId, status: ["draft"]) {
			nodes {
				id
				title
				body {
					atlas_doc_format {
						value
					}
				}
				space {
					id
					key
					alias
				}
			}
		}
	}
`;
